import JwtService from '../common/jwt.service';
import ApiService from '../common/api.service';

const types = {
  LOGIN: 'LOGIN',
  LOGOUT: 'LOGOUT',
  // acrescentei aqui by:bruno
  SET_AVATAR: 'SET_AVATAR',
  SET_TEAM_ID: 'SET_TEAM_ID'
  // fim de acrescimo
};

const state = {
  teamId: null,
  // logged: !!window.localStorage.getItem("user"),
  logged: !!window.localStorage.getItem('token'),
  user: JSON.parse(window.localStorage.getItem('user')),
  userpermissions: JSON.parse(window.localStorage.getItem('userpermissions')),
  avatar: window.localStorage.getItem('avatar') || null

  // tokenagent: JSON.parse(window.localStorage.getItem("tokenagent") || null),
};

const mutations = {
  [types.LOGIN](state) {
    state.logged = true;
  },

  [types.LOGOUT](state) {
    state.logged = false;
    // bruno abaixo
    state.user = null;
    state.userpermissions = null;
    state.teamId = null;
  },

  //acrescentei aqui by: bruno
  [types.SET_AVATAR](state, avatarUrl) {
    if (state.user) {
      state.user.avatar = avatarUrl;
      state.avatar = avatarUrl;
      window.localStorage.setItem('avatar', avatarUrl);
    }
  },
  // fim de acrescimo

  [types.SET_TEAM_ID](state, teamId) {
    state.teamId = teamId;
  }
};

const getters = {
  isLogged: (state) => state.logged,
  userRole: (state) => (state.user ? state.user.role : null),
  user: (state) => state.user, // acrescentei by: bruno
  // userpermissions: (state) => state.userpermissions,
  // tokenagent: state => state.tokenagent

  fotoPerfil: (state) => {
    if (state.user && state.user.avatar) {
      // Aqui, adicionamos o domínio do S3 à URL relativa
      return `https://app-sistemacpv.s3.amazonaws.com${state.user.avatar}`;
    }
    return ''; // Caso não tenha foto de perfil, retorna uma string vazia
  }
};

const actions = {
  login({ commit }, response) {
    let data = response.data;

    JwtService.saveToken(data.access_token);
    commit(types.LOGIN);
    // state.logged = true;
    ApiService.setHeader();

    // state.tokenagent = data.tokenagent;
  },
  authUser({ commit }, response) {
    let data = response.data;
    JwtService.saveUser(data.user);
    JwtService.saveUserPermissions(data.userSistemaCPVPermissions);
    state.user = data.user;
    state.userpermissions = data.userSistemaCPVPermissions;
    // bruno para baixo
    const avatarUrl = data.user.avatar;
    commit(types.SET_AVATAR, data.user.avatar); // acrescentei aqui
    commit(types.SET_TEAM_ID, data.teamId);
    // commit('SET_USER', data.user);
    // commit('SET_USERPERMISSIONS', data.userSistemaCPVPermissions)
    // state.permissions = response;
  },

  logout({ commit }) {
    ApiService.get('auth/logout').then((response) => {
      if (response.data.status == 'success') {
        // acrescentei aqui
        commit(types.LOGOUT);
        // // fim do que fiz
        // state.user = null;
        // state.userpermissions = null;
        // state.logged = false;
        // state.userRole = null;
        // state.teamId = null;
        ApiService.destroyHeader();
        JwtService.destroyToken();
        JwtService.destroyUser();
        JwtService.destroyUserPermissions();
        window.location.href = '/login';
      } else {
        alert('Erro!');
      }
    });
  },
  logoutInvalidToken({ commit }) {
    ApiService.destroyHeader();
    // acrescentei aqui  by: bruno
    commit(types.LOGOUT);
    // Fim do que fiz
    // state.user = null;
    // state.userpermissions = null;
    // state.logged = false;
    // state.userRole = null;
    // state.setTeamId = null;
    JwtService.destroyToken();
    JwtService.destroyUser();
  },

  changeAvatar({ commit }, avatar) {
    // console.log(avatar);
    commit(types.SET_AVATAR, avatar);
    // state.user.avatar = avatar;
  },

  // acrescentei by: bruno
  setUserAvatar({ commit }, avatarUrl) {
    // console.log(avatar);
    commit(types.SET_AVATAR, avatarUrl);
    // state.user.avatar = avatar;
  },

  setTeamId({ commit }, teamId) {
    commit(types.SET_TEAM_ID, teamId);
  }
};

export default {
  state,
  mutations,
  getters,
  actions
};
